module.exports = __webpack_public_path__ + "static/media/17.acd3adc7.jpg";